import { Contact } from '@/common/type';
import request from '@/utils/request';

export type DuplicateReferenceType = 'mbl' | 'hbl' | 'container' | 'invoice';

export interface DuplicateReferenceItem {
  type: DuplicateReferenceType;
  value: string;
  shipment_ext_id?: string;
  shipment_type?: string;
  entity_ext_id?: string;
}

export type ContactDuplicate = Pick<Contact, 'id' | 'ext_id' | 'name' | 'code' | 'address'> & {
  similarity: number;
  same_usci: boolean;
};
export interface ContactDuplicateItem {
  type: 'contact';
  value: string;
  usci_no?: string;
}

export interface DuplicateReferenceResult {
  type: DuplicateReferenceType | 'contact';
  matches?: ContactDuplicate[];
  total?: number;
  value: string;
  duplicate: boolean;
}

export interface DuplicateReferenceResponse {
  enabled: boolean;
  results: DuplicateReferenceResult[];
}

export const checkDuplicateReferences = (
  items: (DuplicateReferenceItem | ContactDuplicateItem)[],
  options: { rethrowErrors?: boolean } = {},
) =>
  request<DuplicateReferenceResponse>('/duplicate-references/check', {
    ...options,
    method: 'POST',
    data: { items },
  });
